import { useState } from "react";

const useLoader = (Loader) => {
  const [isLoading, setIsLoading] = useState(false);

  return [isLoading ? <Loader /> : null, (option) => setIsLoading(!!option)];
};

export default useLoader;
